import React, { useState } from 'react';
import { Button } from "@mui/material";
import EditPaymentSettingsPage from './EditPaymentSettingsPage';

interface PaymentInfoProps {
  storeId: number;
  paymentInfo: any;
  onPaymentSuccess: (newTransaction: any) => void;
}

const PaymentInfo: React.FC<PaymentInfoProps> = ({ storeId, paymentInfo }) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleSuccess = () => {
    setTimeout(() => {
      setIsEditing(false);
    }, 1000);
  };

  const checkDetails = paymentInfo?.check_details;

  return (
    <div className="payment-info-container">
      <div className="payment-info-title-row">
        <h3 className="payment-details-title">Payment Details</h3>
        {!isEditing && (
          <div className="payment-info-update-btn">
            <Button 
              variant="contained" 
              disableElevation
              className="payouts-make-payment-btn"
              onClick={() => setIsEditing(true)}
            >
              Edit
            </Button>
        </div>
        )}
      </div>

      {isEditing ? (
        <EditPaymentSettingsPage 
          storeId={storeId}
          inline={true}
          initialData={paymentInfo}
          onSuccess={handleSuccess}
          onCancel={() => setIsEditing(false)}
        />
      ) : (
      <div className="payment-info-header">
        <div className="check-details">
          {paymentInfo ? (
            <>
              <p><strong>Store Owner:</strong> {paymentInfo.store_owner_name}</p>
              <p><strong>Payment Method:</strong> {paymentInfo.store_payment_method}</p>
              {paymentInfo.store_payment_method !== 'check' && paymentInfo.store_business_email && <p><strong>Business Email:</strong> {paymentInfo.store_business_email}</p>}
              {checkDetails && (
                <>
                  <p><strong>Pay To:</strong> {checkDetails.fullname}</p>
                  <p><strong>Email:</strong> {checkDetails.email}</p>
                  <p><strong>Phone:</strong> {checkDetails.phone}</p>
                  <p>
                    <strong>Address:</strong> {checkDetails.address1}
                    {checkDetails.address2 ? `, ${checkDetails.address2}` : ''}, {checkDetails.city}, {checkDetails.state}, {checkDetails.country} {checkDetails.zip_code}
                  </p>
                </>
              )}
            </>
          ) : (
            <p>No payment information available.</p>
          )}
        </div>
      </div>
    )}
    </div>
  );
};

export default PaymentInfo;
